import { useNavigate } from 'react-router-dom';

import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const ListTemplatesScreen = ({templates}) => {
  const navigate = useNavigate();
  return (
    <Grid container spacing={2}>
        {templates.map(t => (
          <Grid item xs={12} sm={6} md={3}>
            <Paper 
              style={{
                cursor: 'pointer',
              }}
              onClick={() => 
                navigate('/providers/settings/event-templates/' + t.id + '/session-types/new')
            }>
              <Stack spacing={1} padding={1}>
                <Typography variant="h3">{t.title}</Typography>
                <Stack direction='row' spacing={1}>
                  {!!t.category && <Chip color='default' label={t.category} />}
                  {!!t.subcategory && <Chip color='default' label={t.subcategory} />}
                </Stack>
              </Stack>
            </Paper>
          </Grid>
        ))}
    </Grid>
  );
};

export default ListTemplatesScreen;